import { TradeVenue } from '@/types/generated/common/types'

/**
 * Venue constraints that are not capabilities: order-label limits, and which venues answer
 * the maker-side RFQ stream. What a venue can place (order types, TIF, flags, RFQ taker,
 * triggers) lives in `venue-capabilities.ts`.
 */
const ORDER_LABEL_RULES: Partial<Record<TradeVenue, { maxLength: number; pattern: RegExp }>> = {
  // Bybit: labels are capped at 36 chars [A-Za-z0-9_-] by the venue service.
  [TradeVenue.TRADE_VENUE_BYBIT]: { maxLength: 36, pattern: /^[A-Za-z0-9_-]*$/ },
}

/**
 * Venues whose service answers the maker-side RFQ_MAKER stream and maker quote commands
 * (oems_v2 docs/rfq-maker-frontend.md §4). Separate from the taker `rfq` capability
 * (`venue-capabilities.ts`): Bybit and Lighter are maker-only (Paradigm BYB settles on Bybit too).
 */
const RFQ_MAKER_VENUES: ReadonlySet<TradeVenue> = new Set([
  TradeVenue.TRADE_VENUE_DERIBIT,
  TradeVenue.TRADE_VENUE_BYBIT,
  TradeVenue.TRADE_VENUE_DERIVE,
  TradeVenue.TRADE_VENUE_LIGHTER,
])

export function venueSupportsRfqMaker(tradeVenue: TradeVenue | null | undefined): boolean {
  return tradeVenue != null && RFQ_MAKER_VENUES.has(tradeVenue)
}

/** Validates an order label against the venue's constraints. Empty labels always pass. */
export function isValidOrderLabel(
  tradeVenue: TradeVenue | null | undefined,
  label: string
): boolean {
  if (!label) return true
  const rule = tradeVenue == null ? undefined : ORDER_LABEL_RULES[tradeVenue]
  if (!rule) return true
  return label.length <= rule.maxLength && rule.pattern.test(label)
}
